export const INIT_BUYCART = 'INIT_BUYCART'
export const ADD_CART = 'ADD_CART'
export const GET_USERINFO = 'GET_USERINFO'
export const RESET_USERINFO = 'RESET_USERINFO'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const ADD_ANIMATION = 'ADD_ANIMATION'
export const SHOW_CART = 'SHOW_CART'
export const REDUCE_CART = 'REDUCE_CART'
export const EDIT_CART = 'EDIT_CART'
export const LOGOUT = 'LOGOUT'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js